<template>
  <v-container v-if="!loading" class="overflow-y-auto">
    <v-expansion-panels
      v-model="panel"
      multiple
    >
      <v-expansion-panel
        v-for="(setting, index) in panelSettings"
        :key="`expansion-panel-pensions-${index}`"
      >
        <v-expansion-panel-header>
          <div>
            <v-chip
              class="pointer"
              color="gray"
              label
              outlined
            >
              {{ setting.title }}
            </v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-text-field
            v-model="search[setting.search]"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            class="pb-4 pt-0 mt-0"
          />
          <v-data-table
            :headers="headers"
            :items="setting.tableItems"
            :search="search[setting.search]"
            :height="tableHeight"
            :hide-default-footer="true"
            :items-per-page="-1"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
  <div v-else class="d-flex justify-center align-center full-height">
    <Loader />
  </div>
</template>

<script>
import { onBeforeMount, ref, computed } from '@vue/composition-api';

import { format, getUnixTime, isBefore, subYears, startOfYear, fromUnixTime } from 'date-fns';
import { getPensionContracts } from '@/helpers/request';

import Loader from '@/components/common/Loader.vue';

export default {
  components: { Loader },
  setup () {
    const loading = ref(false);
    const panel = ref([0]);
    const activePensions = ref([]);
    const historicalPensions = ref([]);

    const search = ref({
      active: '',
      historical: ''
    });

    const tableHeight = computed(() => (panel.value.length === 2 ? window.innerHeight * 0.3 : window.innerHeight * 0.6));

    const headers = ref([
      { text: 'Nom', value: 'fullname', align: 'center', width: '20%' },
      { text: 'Numéro de contrat', value: 'contractNumber', align: 'center', width: '20%' },
      { text: 'Date de début', value: 'startDate', align: 'center', width: '15%' },
      { text: 'Date de fin', value: 'endDate', align: 'center', width: '15%' },
      { text: 'Commande', value: 'orderUuids', align: 'center', width: '30%' }
    ]);

    const panelSettings = computed(() => ([
      { title: 'Pensions Actives', tableItems: activePensions.value, search: 'active' },
      { title: 'Anciennes Pensions', tableItems: historicalPensions.value, search: 'historical' }
    ]));

    onBeforeMount(async () => {
      loading.value = true;
      const periodEnd = getUnixTime(Date.now());
      const periodStart = getUnixTime(startOfYear(subYears(fromUnixTime(periodEnd), 2)));

      const response = await getPensionContracts(periodStart, periodEnd);

      if (response && response.data && response.data.length) {
        const today = new Date();

        (response.data || []).forEach(item => {
          const start = new Date(item.startTimestamp);
          const end = new Date(item.endTimestamp);

          if (isBefore(end, today)) {
            historicalPensions.value.push({
              ...item,
              fullname: `${item.customerFirstname} ${item.customerLastname}`,
              startDate: format(start, 'dd/MM/yyyy'),
              endDate: format(end, 'dd/MM/yyyy'),
              orderUuids: item.orderUuids.join(' // ')
            });
            return;
          }

          activePensions.value.push({
            ...item,
            fullname: `${item.customerFirstname} ${item.customerLastname}`,
            startDate: format(start, 'dd/MM/yyyy'),
            endDate: format(end, 'dd/MM/yyyy'),
            orderUuids: item.orderUuids.join(' // ')
          });
        });
      }

      loading.value = false;
    });

    return { loading, panel, panelSettings, headers, activePensions, historicalPensions, tableHeight, search };
  }
};

</script>

<style scoped>

</style>
